import Header from "../components/headers/BuyNowHeader.js";
import Video from "../components/heroVideos/BuyNowVideo.js";
import Content from "../components/content/BuyNowContent.js";
import Footer from "../components/Footer.js";

function BuyNow(){
    return(
    <div>
        <Header />
        <Video />
        <Content />
        <Footer />
    </div>
    );
}

export default BuyNow;